export enum CompendiumStateEnum {
  Untagged = 0,
  InProgress = 1,
  Tagged = 2,
  Discarded = 3,
}
